"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./sdk/index");
const index_2 = require("./web/index");
exports.segmentConditions = {
    web: index_2.webSegmentConditions,
    sdk: index_1.sdkSegmentConditions,
};
//# sourceMappingURL=segment-conditions.js.map